import {useMutation} from '@tanstack/react-query';
import {PostRequestUploadDocParams} from 'domain/usecases/others/facial-biometric';
import {postUploadDoc} from '../services/postUploadDoc';

export const useUploadDocMutation = () =>
	useMutation({
		mutationFn: (params: PostRequestUploadDocParams) => postUploadDoc(params),
	});
